import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": []
}


const concatTyping = (array1, array2) => {
    const { fromUserId } = array2
    let index = array1.findIndex(el => el.fromUserId === fromUserId);
    if (index > -1) return array1;
    array1.unshift(array2);
    return array1;
}

const removeData = (_state,fromUserId) => {
    let { data = [] } = StateToObj(_state)
    return data.filter((ele)=>(ele.fromUserId !== fromUserId))
}

const typingStatus = createSlice({
    name:'typingStatus',
    initialState,
    reducers:{
        addTypingStatus: (_state,payload)=>{
            let { data = [] } = StateToObj(_state)
               return {
                "id" : uuidv4(),
                "data": concatTyping(data,payload.payload)
               }
        },
        removeTypingStatus:(_state,payload)=>{
            const { payload: { fromUserId = "" } } = payload
            return {
                "id" : uuidv4(),
                "data": removeData(_state,fromUserId)
               }

        }
    }
});

export default typingStatus.reducer
export const addTypingStatus = typingStatus.actions.addTypingStatus
export const removeTypingStatus = typingStatus.actions.removeTypingStatus
